export const openInNewBrowserTab = (newTabURL: string): void => {
  if (document !== undefined) {
    const link = document.createElement('a');
    link.href = newTabURL;
    link.target = '_blank';
    link.click();
  }
};
